import React from 'react'
import { TwitterTimelineEmbed, TwitterShareButton, TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed, TwitterMomentShare, TwitterDMButton, TwitterVideoEmbed, TwitterOnAirButton } from 'react-twitter-embed';
import "./Widget.css"

function Widget() {
  return (
    <div className='widget'>
      <div className="widget--widgetContainer">
        <TwitterTimelineEmbed
        sourceType='profile'
        screenName='Peach_Aviation'
        options={{height:400}}
        />
         <TwitterTimelineEmbed
        sourceType='profile'
        screenName='FukuokaAirport'
        options={{height:400}}
        />
      </div>
    </div>
  )
}

export default Widget